module.exports = __webpack_public_path__ + "static/CaslonGraD.0b6c8547.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CaslonGraD.woff
// module id = 631
// module chunks = 168707334958949